import { DataGrid } from 'Common/CusomReactGrid/CustomDataGrid'
import NumberConversion from 'Utils/NumberConversion';
import React, { useState } from 'react'
import PropTypes from 'prop-types';
import CardPaymentPopup from '../PatientPaymentDetail/CardPaymentPopup/CardPaymentPopup';
import StatementPopup from 'Popups/StatementPoup/StatementPopup';
import ConfirmationPopup from 'Popups/ConfirmationPopup/ConfirmationPopup';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import { toast } from 'react-toastify';
import api from 'http';
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader';
import Dropdown from 'Common/DropDown/Dropdown';
import { Tooltip } from 'react-tooltip'
import CopyToClipboard from 'Common/CopyToClipboard ';
import { PAYMENT_METHODS } from 'Common/Constants';
import MaskPhoneNumber from 'Utils/MaskPhoneNumber';
import PaymentRequestResendPopup from 'Popups/PaymentRequestResendPopup/PaymentRequestResendPopup';
import { DELETED_SUCCESSFULLY } from 'Common/ToastConstants';
import ThreeDotsIcon from 'SVGS/ThreeDotsIcon';

const RequestPaymentSearchGrid = ({ rows, handlePayment, handlePerRowsChange, handlePageChange, paramModel, allowPatientCol, handleSubmit }) => {
    const [paymentPopup, setPaymentPopup] = useState({
        status: false,
        rowData: null
    })
    const [loading, setLoading] = useState(false)
    const [deletePopup, setDeletePopup] = useState({
        status: false,
        id: 0
    })
    const [resentPopup, setResentPopup] = useState({
        rowData: null,
        status: false,
    })
    const [openStatementPopup, setOpenStatementPopup] = useState({
        rowData: null,
        status: false
    })

    const closePaymentPopup = (row) => {
        setPaymentPopup({
            status: false,
            rowData: null
        })
    }
    const handleOpenDeletePopup = (row) => {
        setDeletePopup({ status: true, id: row.id })
    }
    const handleCancelDeletePopup = () => {
        setDeletePopup({ status: false, id: 0 })

    }
    const handleConfirmDeletePopup = async () => {

        try {
            setLoading(true)
            const payload = {
                ids: [String(deletePopup.id)],
                inActive: true,
                practiceId: 0,
                inActiveReason: "string"
            };
            await api.post(`${process.env.REACT_APP_TC_PMS}/api/PatientPayment/DeletePaymentRequest`, payload);
            toast.success(DELETED_SUCCESSFULLY);
            handleSubmit()
        } catch (error) {
            ErrorHandlingMessage(error);
        } finally {
            setDeletePopup({ status: false, id: 0 })
            setLoading(false)
        }
    };
    const handleOpenResentPopup = (row) => {
        setResentPopup({ status: true, rowData: row })
    }
    const handleCancelResentPopup = () => {
        setResentPopup({ status: false, rowData: null })

    }
    const columns = [
        {

            name: "Request ID", key: "id",
            width: 90,

        },

        {
            // width: 130,
            name: "Patient Name", width: 190, key: "paymentFrom",
        },
        {
            // width: 130,
            name: "Location", width: 100, key: "locationName",
        },
        {
            width: 130,
            name: "Amount", key: "amount",
            formatter: (({ row }) => <>{NumberConversion(row.amount)}</>)
        },

        { width: 120, name: "Date Requested", key: "receivedDate" },
        {
            width: 140, name: "Payment Source", key: "paymentSource",
            formatter: ({ row }) => <span>{(row.paymentMethod === PAYMENT_METHODS.CASH || row.paymentMethod === PAYMENT_METHODS.CHECK) ? <span className='flex items-center h-full'>External </span> : <span className='flex items-center h-full'>{row.paymentSource} </span>}</span>,
        },
        {
            name: "Sent via", key: "sentVia", width: 220,
            formatter: ({ row }) => {
                const isNumber = !isNaN(row.sentTo);
                return (
                    <div>
                        <span data-tooltip-id="sentViaEmail_tooltip" data-tooltip-variant="light"
                            data-some-relevant-attr={row.sentTo}
                            data-sent-via={row.sentVia}
                        >
                            {isNumber ? MaskPhoneNumber(row.sentTo) : row.sentTo?.split(",")[0]}  </span>
                    </div>)
            }
        },
        {
            name: "Memo", key: "memo", width: 250,
            formatter: ({ row }) => (
                <span
                    data-tooltip-id="requestPaymentMemo_tooltip"
                    data-tooltip-content={row.memo}
                    className="block max-w-[240px] overflow-hidden text-ellipsis whitespace-nowrap"
                >
                    {row.memo}
                </span>
            )
        },
        {
            name: "Added By", key: "addedBy", width: 180
        },

        {
            width: 80,
            name: "Action", key: "",
            formatter: ({ row }) => {
                return (
                    <div className="flex items-center justify-center h-full">
                        <Dropdown>
                            <Dropdown.Button>
                                <ThreeDotsIcon />
                            </Dropdown.Button>
                            <Dropdown.Menu>
                                    <>
                                        <Dropdown.MenuItem
                                        className="group rdx_item"
                                        onSelect={() => handleOpenResentPopup(row)} 
                                        >
                                        Resend
                                        </Dropdown.MenuItem>
                                        <Dropdown.MenuItem
                                        className="group rdx_item"
                                        onSelect={() => handleOpenDeletePopup(row)} 
                                        >
                                        Delete
                                        </Dropdown.MenuItem>
                                    </>
                  
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                )
            },
            cellClass: "showDropdownInGrid"
        },
    ].filter((v) => v);
    return (
        <>
            {loading && <FullPageLoader allowFullScreen />}
            <Tooltip opacity={1} style={{ zIndex: 12, minWidth: 150, maxWidth: 450, boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }} id="requestPaymentMemo_tooltip" />
            <Tooltip clickable opacity={1} style={{ zIndex: 12, minWidth: 150, maxWidth: 450, boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }} id="sentViaEmail_tooltip"
                render={({ content, activeAnchor }) => {
                    const sentTo = activeAnchor?.getAttribute('data-some-relevant-attr') || 'not set'
                    return (
                        (
                            <div>
                                <h3 className="pb-1 mb-2 font-semibold border-b">Sent Via</h3>
                                <div>
                                    {sentTo.split(",").map((item) => {
                                        const trimmedItem = item.trim();
                                        const isPhoneNumber = /^\d{10,}$/.test(trimmedItem); // Adjust the regex to your phone number format
                                        const displayText = isPhoneNumber ? MaskPhoneNumber(trimmedItem) : trimmedItem;
                                        return (
                                            <CopyToClipboard key={trimmedItem} textToCopy={displayText}>
                                                <span className="bg-[#F4F6F7] mb-2 rounded px-2 py-1 inline-flex items-center gap-1 text-black">
                                                    {displayText}
                                                </span>
                                            </CopyToClipboard>
                                        );
                                    })}
                                </div>
                            </div>

                        )
                    )
                }}
            />
            {deletePopup.status && <ConfirmationPopup
                heading="Confirmation"
                subHeading="Are you sure you want to Delete?"
                onConfirm={handleConfirmDeletePopup}
                onCancel={handleCancelDeletePopup}
                buttonTitle="Delete"
            />}
            {resentPopup.status &&
                <PaymentRequestResendPopup onClose={handleCancelResentPopup} row={resentPopup.rowData} />
            }
            {
                paymentPopup.status && <CardPaymentPopup onClose={closePaymentPopup} paymentModel={paymentPopup.rowData} />
            }
            {
                openStatementPopup.status && <StatementPopup data={openStatementPopup.rowData} onClose={() => setOpenStatementPopup({ status: false })} />
            }


            <DataGrid
                formId='patientPaymentSearchGrid'
                paginationDefaultPage={1}
                columns={columns}
                rows={rows}
                contentBasedMaxHeight={400}
                contentBasedHeight={allowPatientCol}
                paginationPerPage={
                    paramModel.perPage
                }
                pagination={{
                    perPage: paramModel.perPage,
                    pageNo: paramModel.pageNo,
                    totalCount: paramModel.totalCount,
                }}
                manualPagination={true}
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationTotalRows={paramModel.totalCount}
                // gridHeightOffset={300}

            // dynamicClass='patientPaymentDynamicClass allowDropDown'
            // height="100%"
            // id="PatientPaymentSearchGrid"
            // minHeight='265px'
            // maxHeight='265px'
            />

        </>
    )
}

export default RequestPaymentSearchGrid

RequestPaymentSearchGrid.propTypes = {
    rows: PropTypes.array.isRequired,
    handlePayment: PropTypes.func.isRequired,
    handlePerRowsChange: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    paramModel: PropTypes.object.isRequired,
    allowPatientCol: PropTypes.bool.isRequired,
};